import Video from 'src/components/common/Video/index'
import './styles.scss'

type VideoCollectionProps = {
  src: string
  settings: {
    controlsOn: boolean
    muteOn: boolean
    playAuto: boolean
    loopingVideo: boolean
  }
  marginTop?: string
  marginBottom?: string
}

const VideoCollection = (data: VideoCollectionProps) => {
  const { src, settings } = data

  return (
    <div
      className="collection-container"
      style={{
        marginTop: `${data?.marginTop ?? ' '}`,
        marginBottom: `${data?.marginBottom ?? ' '}`,
      }}
    >
      <div className="collection-container__video">
        <Video
          videoSrcURL={src}
          videoTitle=""
          controlsVideo={settings.controlsOn}
          autoVideo={settings.playAuto}
          soundVideo={settings.muteOn}
          loopingVideo={settings.loopingVideo}
        />
      </div>
    </div>
  )
}

export default VideoCollection
